<script>
  import * as authService from '../../services/authService'

  import {mapGetters} from 'vuex'

  export default {
    name: 'app-sidebar',
    computed: {
      ...mapGetters(['isLogged', 'currentUser', 'showSidebar'])
    },
    data () {
      return {
        activeIndex: this.isLogged ? 'home' : 'registration.index'
      }
    },
    watch: {
      '$route': function (val) {
        if (val.name) {
          let routeSplit = val.name.split('.')
          this.activeIndex = routeSplit.length > 2 ? routeSplit[0] + '.' + routeSplit[1] : routeSplit[0]
        }
      }
    },
    mounted () {
      this.getCurrentRoute()
    },
    methods: {
      getCurrentRoute () {
        if (this.$route.name) {
          let routeSplit = this.$route.name.split('.')
          this.activeIndex = routeSplit.length > 2 ? routeSplit[0] + '.' + routeSplit[1] : routeSplit[0]
        }
      },
      onLogout () {
        authService.logout()
          .then(() => {
            this.$router.push({name: 'registration.home'})
          })
          .catch(e => {
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <aside class="sidebar"
           v-bind:class="{ '-hidden': !showSidebar }">
        <nav class="sidebar-menu">
            <span class="header">Navegação</span>
            <router-link :to="{name: 'home'}"
                         v-bind:class="{'-active': activeIndex === 'home'}">
                <span class="sidebar-icon">
                    <i class="fa fa-home"></i>
                </span>
                <span class="text">Página Inicial</span>
            </router-link>
            <router-link :to="{name: 'registration.index'}"
                         v-bind:class="{'-active': activeIndex === 'registration'}">
                <span class="sidebar-icon">
                    <i class="fa fa-calendar-plus-o"></i>
                </span>
                <span class="text">Inscrições</span>
            </router-link>
            <router-link :to="{name: 'submission.index'}"
                         v-bind:class="{'-active': activeIndex === 'submission'}">
                <span class="sidebar-icon">
                    <i class="fa fa-file-o"></i>
                </span>
                <span class="text">Submissões</span>
            </router-link>
            <router-link :to="{name: 'evaluation.index', params: {status: 'assigned'}}"
                         v-bind:class="{'-active': activeIndex === 'evaluation'}">
                <span class="sidebar-icon">
                    <i class="fa fa-file-text-o"></i>
                </span>
                <span class="text">Avaliações</span>
            </router-link>
            <a href="#" @click="onLogout">
                <span class="sidebar-icon">
                    <i class="fa fa-sign-out"></i>
                </span>
                <span class="text">Sair</span>
            </a>
        </nav>
    </aside>
</template>

<style lang="scss">
    .sidebar {
        width: 200px;
        min-height: 100vh;
        height: 100%;
        background-color: #FFFFFF;
        -webkit-box-shadow: 1px 0 1px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 1px 0 1px 0 rgba(0, 0, 0, 0.1);
        position: absolute;
        left: 0;
        top: 0;
        z-index: 90;
        transition: all .3s ease-in-out;

        > .sidebar-menu {
            padding-top: 80px;

            > span,
            > a {
                display: block;
                padding: 0 8px;

                &.header {
                    background-color: #f2f2f2;
                    line-height: 24px;
                    font-size: 10px;
                    text-transform: uppercase;
                    margin-top: 15px;
                    font-weight: 700;
                    color: #4d4d4d;
                }
            }
            > a {
                line-height: 36px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                text-decoration: none;
                -webkit-transition: all .2s ease-out;
                transition: all .2s ease-out;

                .sidebar-icon {
                    width: 26px;
                    text-align: center;

                    &.icon-right {
                        font-size: 12px;
                    }
                }
                span.text {
                    color: #7a7a7a;
                    font-size: 14px;
                    letter-spacing: -0.02em;
                }
                .sidebar-icon {
                    color: #E0933F;
                }

                &.-active,
                &:active,
                &:focus {
                    background-color: #2F423A;
                    span.text {
                        color: #FFF;
                    }
                }
                &:hover {
                    background-color: #4c6b5e;
                }
            }
        }
    }

    @media all and (max-width: 1024px) {
        .sidebar {
            position: fixed;
            left: 0;
            top: 0;
            overflow: auto;
            height: 100vh;

            > .sidebar-menu {
                padding-top: 80px;
            }

            &.-hidden {
                left: -230px;
            }
        }
    }

    @media all and (max-width: 768px) {
        .sidebar {
            > .sidebar-menu {
                padding-top: 55px;
            }
        }
    }

</style>
